export function Step({ n, title, hint, children, testId }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-6 sm:p-8" data-testid={testId}>
      <div className="flex items-start gap-4 mb-6">
        <div className="h-9 w-9 shrink-0 rounded-sm bg-[#1E2A78] text-[#FFD700] font-display font-extrabold flex items-center justify-center">{n}</div>
        <div>
          <h2 className="text-base md:text-lg font-display font-bold text-[#0F172A]">{title}</h2>
          {hint && <p className="text-sm text-slate-500 mt-0.5">{hint}</p>}
        </div>
      </div>
      {children}
    </div>
  );
}

export const Q_INPUT = "w-full px-4 py-3 bg-white border border-slate-200 rounded-sm outline-none focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/20 text-sm";
export const Q_LABEL = "block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2";
